import { automapDealerPortalPath } from "./automapDealerPortalRoutes";

export const ONBOARDING_CATEGORY_ORDER = [
  "business_profile",
  "contact_channels",
  "verification",
  "inventory",
  "photos",
  "leads",
  "training",
  "launch_readiness",
];

export const ONBOARDING_LAUNCH_TARGETS = {
  readinessScore: 80,
  activeListings: 10,
  photoCoveragePct: 80,
  freshnessPct: 80,
};

export const DEALER_SELF_ATTEST_CHECKLIST_KEYS = new Set([
  "lead_inbox_reviewed",
  "whatsapp_routing_tested",
  "dashboard_reviewed",
  "response_expectations_understood",
  "trial_terms_explained",
]);

function publicProfilePath(dealerSlug) {
  return dealerSlug ? `/v/automap/concesionarios/${dealerSlug}` : automapDealerPortalPath("plan");
}

/**
 * Portal routes and behavior for each onboarding checklist key.
 * @param {{ dealerSlug?: string }} ctx
 */
export function resolveOnboardingItemAction(itemKey, ctx = {}) {
  const slug = ctx.dealerSlug || "";
  const actions = {
    business_name_confirmed: { to: publicProfilePath(slug), labelKey: "reviewProfile" },
    public_name_confirmed: { to: publicProfilePath(slug), labelKey: "reviewProfile" },
    logo_added: { to: automapDealerPortalPath("plan"), labelKey: "contactAutoMapa" },
    address_confirmed: { to: automapDealerPortalPath("plan"), labelKey: "contactAutoMapa" },
    city_neighborhood_confirmed: { to: publicProfilePath(slug), labelKey: "reviewProfile" },
    whatsapp_confirmed: { to: automapDealerPortalPath("plan"), labelKey: "contactAutoMapa" },
    contact_person_confirmed: { to: automapDealerPortalPath("plan"), labelKey: "contactAutoMapa" },
    public_profile_reviewed: { to: publicProfilePath(slug), labelKey: "reviewProfile", external: true },
    verification_reviewed: { to: automapDealerPortalPath("plan"), labelKey: "contactAutoMapa" },
    inventory_file_received: { to: automapDealerPortalPath("inventario/importar"), labelKey: "uploadInventory" },
    inventory_imported: { to: automapDealerPortalPath("inventario/importar"), labelKey: "uploadInventory" },
    listings_cleaned: { to: automapDealerPortalPath("inventario/calidad"), labelKey: "reviewQuality" },
    listings_have_photos: { to: `${automapDealerPortalPath("inventario")}?missingPhotos=true`, labelKey: "addPhotos" },
    listings_have_price_mileage: { to: automapDealerPortalPath("inventario/calidad"), labelKey: "fixListings" },
    listings_confirmed_available: {
      to: `${automapDealerPortalPath("inventario")}?needsConfirmation=true`,
      labelKey: "confirmAvailability",
    },
    min_ten_active_listings: { to: automapDealerPortalPath("inventario/nuevo"), labelKey: "addVehicles" },
    lead_inbox_reviewed: { to: automapDealerPortalPath("leads"), labelKey: "openLeads", selfAttest: true },
    whatsapp_routing_tested: { to: automapDealerPortalPath("leads"), labelKey: "testWhatsapp", selfAttest: true },
    dashboard_reviewed: { to: automapDealerPortalPath("dashboard"), labelKey: "openDashboard", selfAttest: true },
    response_expectations_understood: { to: automapDealerPortalPath("reportes"), labelKey: "readGuide", selfAttest: true },
    trial_terms_explained: { to: automapDealerPortalPath("plan"), labelKey: "reviewPlan", selfAttest: true },
    launch_ready_approval: { to: automapDealerPortalPath("plan"), labelKey: "awaitingApproval", adminOnly: true },
  };

  return actions[itemKey] || { to: automapDealerPortalPath("dashboard"), labelKey: "getStarted" };
}

export function groupChecklistByCategory(items = []) {
  const grouped = new Map();
  for (const item of items) {
    const category = item.category || "training";
    if (!grouped.has(category)) grouped.set(category, []);
    grouped.get(category).push(item);
  }
  return ONBOARDING_CATEGORY_ORDER.filter((category) => grouped.has(category)).map((category) => ({
    category,
    items: grouped.get(category),
  }));
}
